import { inject, Service } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectProfile } from '../selectors/profile.selector';
import { profileActions } from '../actions/profile.actions';

@Service()
export class ProfileFacade {
    private readonly store = inject(Store);

    readonly profile = this.store.selectSignal(selectProfile);

    // Dispatch
    clear(): void {
        this.store.dispatch(profileActions.clear());
    }
}
